<template>
  <div class="c-product-card-price-area">
    <div
      class="c-product-card-price-area__price"
      :class="{ isSale: product.isSale }"
    >
      ¥
      <strong :class="size">{{ product.priceText }}</strong>
      税込
    </div>
    <div v-if="product.isSale" class="c-product-card-price-area__strikethrough">
      ¥
      <strong>{{ product.comparePriceText }}</strong>
      税込
    </div>
  </div>
</template>

<script>
import Product from '~/js/models/product'
import FSProduct from '~/js/models/FSProduct'

export default {
  name: 'ComponentProductCardPriceArea',
  props: {
    product: {
      type: [Product, FSProduct],
      required: true,
      default: () => {
        return new Product()
      },
    },
    size: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-price-area {
  &__price {
    color: variables.$color-accent;
    font-size: 10px;

    @include mixins.screen-desktop {
      font-size: 13px;
    }

    strong {
      font-size: 20px;
      font-weight: normal;

      &.small {
        @include mixins.screen-mobile {
          font-size: 16px;
        }
      }

      @include mixins.screen-desktop {
        font-size: 24px;
      }
    }

    &.isSale {
      color: variables.$color-red;

      strong {
        font-weight: 700;
      }
    }
  }

  &__strikethrough {
    color: variables.$color-text-gray;
    
    text-decoration: line-through;
    position: relative;
    font-size: 6px;

    @include mixins.screen-desktop {
      font-size: 8px;
    }

    strong {
      font-size: 8px;

      @include mixins.screen-desktop {
        font-size: 12px;
      }
    }
  }

  &.narrow {
    letter-spacing: -0.3px;
    font-size: 10px;
    line-height: 1.15;

    > strong {
      font-size: 16px;
    }
  }

  &__meta {
    display: inline-block;
  }

  &.narrow &__meta {
    font-weight: 300;
    line-height: 1.5;
  }
}
</style>
